import React from "react";
import RatingCircles from "/src/helpers/components/ratingCircles.jsx";
import OfficialRating from "/src/helpers/components/officalRating.jsx";
import FilterFigure from "./filterFigure.jsx";
const FilterStarRatingItem = ({ option, type, idx, onChange, selected }) => {
    const inputId = `filter-${type}-${idx}`;
    return (
        <div key={option.value} className="filter-row">
            <div className="flex h-5 shrink-0 items-center">
                <div className="group grid size-4 grid-cols-1">
                    <input
                        onChange={(e) => onChange(e.target)}
                        checked={selected}
                        id={inputId}
                        type="checkbox"
                        className="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                    />
                    <svg
                        fill="none"
                        viewBox="0 0 14 14"
                        className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25"
                    >
                        <path
                            d="M3 8L6 11L11 3.5"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="opacity-0 group-has-checked:opacity-100"
                        />
                        <path
                            d="M3 7H11"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="opacity-0 group-has-indeterminate:opacity-100"
                        />
                    </svg>
                </div>
            </div>
            <label htmlFor={inputId} className="filter-row__label my-auto">
                <OfficialRating rating={option.name} inline={true} />
            </label>
            <FilterFigure option={option} />
        </div>
    );
};

const FilterStarRating = ({ model, events }) => {
    return model.options.map((option, optionIdx) => {
        const isSelected = events.isSelected(model.key, option.key);
        const onChangeHandler = (e) => {
            if (isSelected) {
                events.removeOption(model.key, option.key);
            } else {
                events.setOption(model.key, option.key);
            }
        };
        return (
            <FilterStarRatingItem
                option={option}
                selected={isSelected}
                type={model.key}
                idx={optionIdx}
                key={optionIdx}
                onChange={onChangeHandler}
            />
        );
    });
};
export default FilterStarRating;
